import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { UncontrolledCollapse } from "reactstrap";
import { Collapse } from "reactstrap";
import { FaBroadcastTower, FaLock, FaLockOpen, FaCheckCircle, FaTimesCircle, FaCog, FaInfoCircle/* , FaCloudDownloadAlt */ } from "react-icons/fa";
import ConstData from "../../../lib/ConstData";
import Alerts from "../../etc/list/Alerts";
// 20260828 로컬 서버 이름 인라인 수정용 공용 컴포넌트
import InlineEditCell from "../common/InlineEditCell";
import { getReportTokenState, getRabbitmqVersionSupport } from "../../../lib/localServerFilters";
import "./WebLocalServerInfo.css";

// 20260814 로컬 서버 상세 정보의 마지막 업데이트 상태를 이력 화면과 동일하게 구분한다.
const getUpdateStatusStyle = (status) => {
    switch (String(status || "").toUpperCase()) {
        case "SUCCESS": return "success";
        case "STARTED":
        case "RUNNING": return "progress";
        case "REBOOT_PENDING": return "pending";
        case "PARTIAL": return "warning";
        case "FAILED": return "failed";
        default: return "unknown";
    }
};

// 20260828 코덱 감지 상태를 관리자 상세정보에서 동일한 배지 형태로 표시한다.
const getCodecStateClass = (value) => value === "Y" ? "online" : value === "N" ? "offline" : "neutral";
const getCodecStateLabel = (value) => value === "Y" || value === "N" ? value : "-";
// 20260828 명령 ACK 코드를 화면용 배지 스타일과 다국어 문구로 변환한다.
const getCommandStatusStyle = (status) => {
    switch (String(status || "").toUpperCase()) {
        case "R": return "progress";
        case "A": return "progress";
        case "C": return "success";
        case "F": return "failed";
        case "T": return "warning";
        default: return "unknown";
    }
};

// 20260828 새 명령 추가 시 commandName·labelKey를 등록하고, 각 언어 compo1.json에 labelKey 번역을 추가한다.
// 실행 버튼이 필요한 명령은 아래 버튼 영역과 sendAdminCommand 분기에도 함께 연결해야 한다.
const commandUiDefinitions = [
    { commandName: "commandCapabilityRequest", labelKey: "명령_기능_확인" },
    { commandName: "codecConfigApply", labelKey: "명령_코덱_재설정" },
    { commandName: "restartLocalServer", labelKey: "명령_서버_재시작" }
];

const WebLocalServerInfo = ({ idx, localServer_info, list_localSite, list_localServerType, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const [lLocaServerInfo, setLocaServerInfo] = useState(localServer_info);
    const [lLocalSiteInfo, setLocalSiteInfo] = useState({ idx: 0, localSiteSeq: -1, localSiteName: "" });

    const [lPortNumber, setPortNumber] = useState("");
    const [lMemo, setMemo] = useState("");
    const [lHistorySeq, setHistorySeq] = useState(-1);

    const [isLocalSiteOpen, setIsLocalSiteOpen] = useState(false);
    const [isPortInfoOpen, setIsPortInfoOpen] = useState(false);

    // 260804 상세정보(읽기전용) / 상세설정(로그인 허용·자동 로그인·업데이트 허용) 패널 상태
    const [isDetailInfoOpen, setIsDetailInfoOpen] = useState(false);
    const [isConfigOpen, setIsConfigOpen] = useState(false);
    const [lAllowLoginYn, setAllowLoginYn] = useState("N");
    const [lAutoLoginYn, setAutoLoginYn] = useState("N");
    const [lUpdateAllowYn, setUpdateAllowYn] = useState("Y");
    const [lClassMonitorAllowYn, setClassMonitorAllowYn] = useState("N");
    const [lLocalServerType, setLocalServerType] = useState("UNKNOWN");
    const [configAlert, setConfigAlert] = useState({ kind: ConstData.ALERT_KIND.NONE, message: "" });
    // 20260828 이름 인라인 수정 결과도 상세설정 저장과 동일하게 해당 서버 행에서만 표시한다
    const [nameAlert, setNameAlert] = useState({ kind: ConstData.ALERT_KIND.NONE, message: "" });
    const [commandAlert, setCommandAlert] = useState({ kind: ConstData.ALERT_KIND.NONE, message: "" });
    // 20260828 로컬 서버 명령 ACK 대기 중 중복 요청을 막고 진행 상태를 표시한다.
    const [isCommandPending, setIsCommandPending] = useState(false);
    const [isCodecConfigOpen, setIsCodecConfigOpen] = useState(false);
    const [codecConfig, setCodecConfig] = useState({ VP9: "Y", VP8: "Y", H264: "Y" });
    const [pendingCommandName, setPendingCommandName] = useState("");

    useEffect(() => {
        // 컴포넌트가 마운트될 때 collapse 닫기
        setIsLocalSiteOpen(false);
        setIsPortInfoOpen(false);
        setIsDetailInfoOpen(false);
        setIsConfigOpen(false);

        return () => {
            // 컴포넌트가 언마운트될 때 remoteForward 데이터 정리 요청
            handleSelectedFunc({ selectedFunc: "CLEAR_REMOTE_FORWARD_INFO", data: { localServer_info } });

            // 컴포넌트가 언마운트될 때 collapse 닫기
            setIsLocalSiteOpen(false);
            setIsPortInfoOpen(false);
            setIsDetailInfoOpen(false);
            setIsConfigOpen(false);
        };
    }, []);

    useEffect(() => {
        if (list_localSite && list_localSite.length > 0) {
            setLocalSiteInfo({ idx: 0, localSiteSeq: list_localSite[0].localSiteSeq, localSiteName: list_localSite[0].localSiteName });
        }
    }, [list_localSite]);

    /* useEffect(() => {
        if (localServer_info && localServer_info.localSiteSeq !== -1) {
            let c_local_site_info = { idx: 0, localSiteSeq: -1, localSiteName: "" };

            if (list_localSite && list_localSite.length > 0) {
                c_local_site_info = list_localSite.find(info => info.localSiteSeq === localServer_info.localSiteSeq);
                let index = list_localSite.indexOf(c_local_site_info);

                setLocalSiteInfo({ idx: index, localSiteSeq: c_local_site_info.localSiteSeq, localSiteName: c_local_site_info.localSiteName });
            }
        }
    }, [localServer_info]); */

    useEffect(() => {
        // console.log("useEffect[localServer_info] => ", localServer_info);
        if (localServer_info) {
            setLocaServerInfo(localServer_info);
            setPortNumber(localServer_info.portNumber && localServer_info.portNumber !== -1 ? localServer_info.portNumber : "");
            setMemo(localServer_info.historyMemo ? localServer_info.historyMemo : "");
            setHistorySeq(localServer_info.historySeq ? localServer_info.historySeq : -1);

            // 260804 상세설정 토글 초기값 동기화 (NULL은 허용 안 함/꺼짐으로 취급 - 백엔드 로직과 동일)
            setAllowLoginYn(localServer_info.allowLoginYn === "Y" ? "Y" : "N");
            setAutoLoginYn(localServer_info.autoLoginYn === "Y" ? "Y" : "N");
            setUpdateAllowYn(localServer_info.isUpdateAllowed ? "Y" : "N");
            // 20260813 클래스 모니터 허용값을 관리자 상세설정 토글에 동기화한다.
            setClassMonitorAllowYn(localServer_info.classMonitorAllowYn === "Y" ? "Y" : "N");
            // 20260814 저장된 서버 타입을 상세설정 선택값에 동기화한다.
            setLocalServerType(localServer_info.localServerType || "UNKNOWN");
            // 20260917 코덱 명령 편집·처리 중에는 폴링 결과의 이전 값으로 입력 상태를 덮어쓰지 않는다.
            if (!isCodecConfigOpen && !isCommandPending) {
                setCodecConfig({ VP9: localServer_info.codecVp9UseYn === "N" ? "N" : "Y", VP8: localServer_info.codecVp8UseYn === "N" ? "N" : "Y", H264: localServer_info.codecH264UseYn === "N" ? "N" : "Y" });
            }
        }
    }, [localServer_info]);

    useEffect(() => {
        // 20260828 명령 capability를 서버 카드가 열릴 때 조회한다.
        handleSelectedFunc({ selectedFunc: "GET_LOCAL_SERVER_COMMAND_INFO", data: { localServerSeq: localServer_info.localServerSeq } });
    }, [localServer_info.localServerSeq]);

    useEffect(() => {
        if (!localServer_info.commandAlertEventId) return;
        setCommandAlert({ kind: localServer_info.commandAlertKind, message: localServer_info.commandAlertMessage });
        const timer = setTimeout(() => setCommandAlert({ kind: ConstData.ALERT_KIND.NONE, message: "" }), 2500);
        return () => clearTimeout(timer);
    }, [localServer_info.commandAlertEventId]);

    useEffect(() => {
        if (!localServer_info.commandRequestId || !isCommandPending) return;
        // 20260828 명령 요청 후 ACK 상태를 짧게 재조회해 카드에 반영한다.
        let attempts = 0;
        const timer = setInterval(() => {
            attempts += 1;
            handleSelectedFunc({ selectedFunc: "GET_LOCAL_SERVER_COMMAND_INFO", data: { localServerSeq: localServer_info.localServerSeq } });
            if (attempts >= 30) clearInterval(timer);
        }, 3000);
        const timeout = setTimeout(() => setIsCommandPending(false), 90000);
        return () => {
            clearInterval(timer);
            clearTimeout(timeout);
        };
    }, [isCommandPending, localServer_info.commandRequestId, localServer_info.localServerSeq]);

    useEffect(() => {
        if (!isCommandPending || !localServer_info.commandRequestId) return;
        const commandInfo = (localServer_info.commandInfo || []).find(info => info.LAST_REQUEST_ID === localServer_info.commandRequestId);
        if (commandInfo && ["A", "C", "F", "T"].includes(commandInfo.LAST_ACK_STATUS)) {
            setIsCommandPending(false);
            if (pendingCommandName === "codecConfigApply") setIsCodecConfigOpen(false);
        }
    }, [isCommandPending, localServer_info.commandInfo, localServer_info.commandRequestId, pendingCommandName]);

    useEffect(() => {
        if (!localServer_info.configAlertEventId) return;
        // 20260813 상세설정 저장 결과는 해당 로컬 서버 행에서 매번 표시한다.
        setConfigAlert({ kind: localServer_info.configAlertKind, message: localServer_info.configAlertMessage });
        const timer = setTimeout(() => setConfigAlert({ kind: ConstData.ALERT_KIND.NONE, message: "" }), 2500);
        return () => clearTimeout(timer);
    }, [localServer_info.configAlertEventId]);

    // 20260828 이름 인라인 수정 결과도 상세설정 저장과 동일한 방식(해당 행, 2.5초 후 자동 숨김)으로 표시한다.
    useEffect(() => {
        if (!localServer_info.nameAlertEventId) return;
        setNameAlert({ kind: localServer_info.nameAlertKind, message: localServer_info.nameAlertMessage });
        const timer = setTimeout(() => setNameAlert({ kind: ConstData.ALERT_KIND.NONE, message: "" }), 2500);
        return () => clearTimeout(timer);
    }, [localServer_info.nameAlertEventId]);

    useEffect(() => {
        if (lLocaServerInfo && lLocaServerInfo.localSiteSeq !== -1) {
            let c_local_site_info = { idx: 0, localSiteSeq: -1, localSiteName: "" };

            if (list_localSite && list_localSite.length > 0) {
                c_local_site_info = list_localSite.find(info => info.localSiteSeq === lLocaServerInfo.localSiteSeq);
                let index = list_localSite.indexOf(c_local_site_info);

                setLocalSiteInfo({ idx: index, localSiteSeq: c_local_site_info.localSiteSeq, localSiteName: c_local_site_info.localSiteName });
            }
        }
    }, [lLocaServerInfo, list_localSite]);

    // 20260814 원격 포워딩 결과 변경 시 반복 출력되는 확인 로그를 비활성화한다.
    // useEffect(() => {
    //     console.log("useEffect - remoteForwardResult => ", localServer_info.remoteForwardResult);
    // }, [localServer_info.remoteForwardResult]);

    const onChangePortNumber = (e) => {

        let str = e.target.value;
        str = str.replace(/[^0-9]/g, "");
        setPortNumber(str);
    }

    const onChangeMemo = (e) => {
        setMemo(e.target.value);
    }

    const onHandleLocalServerPortNumber = () => {
        if (lPortNumber === "" || lPortNumber < 0) return;

        if (lMemo === "") {
            handleSelectedFunc({ selectedFunc: "CHANGE_LOCAL_SERVER_PORT_NUM", data: { localServer_info, portNumber: lPortNumber } });
        } else {
            handleSelectedFunc({ selectedFunc: "CHANGE_LOCAL_SERVER_PORT_NUM", data: { localServer_info, portNumber: lPortNumber, historyMemo: lMemo } });
        }
    }

    const onChangeSelectLocalSite = (e) => {
        if (list_localSite && list_localSite.length > 0) {
            let idx = e.target.value;
            setLocalSiteInfo({ idx, localSiteSeq: list_localSite[idx].localSiteSeq, localSiteName: list_localSite[idx].localSiteName });
        }
    }

    const onHandleModifyLocalSite = () => {
        handleSelectedFunc({ selectedFunc: "CHANGE_LOCAL_SITE", data: { localServerSeq: localServer_info.localServerSeq, localSiteSeq: lLocalSiteInfo.localSiteSeq, localSiteName: lLocalSiteInfo.localSiteName } });
    }

    // 20260828 로컬 서버 이름 인라인 수정 - 연필 아이콘 확인 클릭 시 즉시 저장
    const onHandleChangeServerName = (newName) => {
        handleSelectedFunc({ selectedFunc: "CHANGE_LOCAL_SERVER_NAME", data: { localServerSeq: localServer_info.localServerSeq, localServerName: newName } });
    }

    const onHandleRemoveServer = () => {
        handleSelectedFunc({ selectedFunc: "DELETE_LOCAL_SERVER", data: localServer_info });
    }

    const toggleLocalSite = () => {
        if (isLocalSiteOpen && list_localSite && list_localSite.length > 0) {
            // 20260813 저장하지 않고 닫은 로컬 사이트 설정은 마지막 저장 상태로 되돌린다.
            const savedLocalSiteInfo = list_localSite.find(info => info.localSiteSeq === localServer_info.localSiteSeq);
            const savedLocalSiteIndex = list_localSite.indexOf(savedLocalSiteInfo);

            if (savedLocalSiteInfo) {
                setLocalSiteInfo({ idx: savedLocalSiteIndex, localSiteSeq: savedLocalSiteInfo.localSiteSeq, localSiteName: savedLocalSiteInfo.localSiteName });
            }
        }
        setIsLocalSiteOpen(!isLocalSiteOpen);
    };
    const togglePortInfo = () => {
        if (isPortInfoOpen) {
            // 20260813 저장하지 않고 닫은 포트 설정은 마지막 저장 상태로 되돌린다.
            setPortNumber(localServer_info.portNumber && localServer_info.portNumber !== -1 ? localServer_info.portNumber : "");
            setMemo(localServer_info.historyMemo ? localServer_info.historyMemo : "");
            setHistorySeq(localServer_info.historySeq ? localServer_info.historySeq : -1);
        }
        setIsPortInfoOpen(!isPortInfoOpen);
    };

    // 260804 상세정보(읽기전용) / 상세설정 토글 및 저장
    const toggleDetailInfo = () => setIsDetailInfoOpen(!isDetailInfoOpen);
    // 20260821 MQTT 포트가 확인된 서버는 업데이트 허용과 별개로 클래스 모니터 허용을 관리한다.
    const isMqttPortAvailable = localServer_info.mqttAvailableYn === "Y";
    const isClassMonitorConfigEnabled = lUpdateAllowYn === "Y" || isMqttPortAvailable;
    const toggleConfig = () => {
        if (isConfigOpen) {
            // 20260813 저장하지 않고 닫은 상세설정은 마지막 저장 상태로 되돌린다.
            setAllowLoginYn(localServer_info.allowLoginYn === "Y" ? "Y" : "N");
            setAutoLoginYn(localServer_info.allowLoginYn === "Y" && localServer_info.autoLoginYn === "Y" ? "Y" : "N");
            setUpdateAllowYn(localServer_info.isUpdateAllowed ? "Y" : "N");
            setClassMonitorAllowYn((localServer_info.isUpdateAllowed || localServer_info.mqttAvailableYn === "Y") && localServer_info.classMonitorAllowYn === "Y" ? "Y" : "N");
            setLocalServerType(localServer_info.localServerType || "UNKNOWN");
            setConfigAlert({ kind: ConstData.ALERT_KIND.NONE, message: "" });
        }
        setIsConfigOpen(!isConfigOpen);
    };

    const onToggleAllowLoginYn = () => {
        const nextAllowLoginYn = lAllowLoginYn === "Y" ? "N" : "Y";
        setAllowLoginYn(nextAllowLoginYn);
        // 20260813 로그인 허용 해제 시 자동 로그인도 함께 해제한다.
        if (nextAllowLoginYn === "N") setAutoLoginYn("N");
    };
    const onToggleAutoLoginYn = () => setAutoLoginYn(prev => prev === "Y" ? "N" : "Y");
    const onToggleUpdateAllowYn = () => {
        const nextUpdateAllowYn = lUpdateAllowYn === "Y" ? "N" : "Y";
        setUpdateAllowYn(nextUpdateAllowYn);
        // 20260821 MQTT 포트가 없을 때만 업데이트 허용 해제와 함께 클래스 모니터를 끈다.
        if (nextUpdateAllowYn === "N" && !isMqttPortAvailable) setClassMonitorAllowYn("N");
    };
    // 20260821 업데이트 허용 또는 MQTT 포트 사용 가능 서버에서 클래스 모니터 허용값을 변경한다.
    const onToggleClassMonitorAllowYn = () => {
        if (isClassMonitorConfigEnabled) {
            setClassMonitorAllowYn(prev => prev === "Y" ? "N" : "Y");
        }
    };

    const onHandleSaveConfig = () => {
        const selectedType = (list_localServerType || []).find(info => info.localServerType === lLocalServerType);
        handleSelectedFunc({
            selectedFunc: "CHANGE_LOCAL_SERVER_CONFIG",
            data: { localServer_info, allowLoginYn: lAllowLoginYn, autoLoginYn: lAllowLoginYn === "Y" ? lAutoLoginYn : "N", updateAllowYn: lUpdateAllowYn, classMonitorAllowYn: isClassMonitorConfigEnabled ? lClassMonitorAllowYn : "N", localServerType: lLocalServerType, localServerTypeName: selectedType ? selectedType.localServerTypeName : localServer_info.localServerTypeName }
        });
    }

    const getCommandInfo = (commandName) => (localServer_info.commandInfo || []).find(info => info.COMMAND_NAME === commandName);
    const isCommandSupported = (commandName) => getCommandInfo(commandName) && getCommandInfo(commandName).SUPPORTED_YN === "Y";
    const hasCapabilityResult = Boolean(getCommandInfo("commandCapabilityRequest") && getCommandInfo("commandCapabilityRequest").LAST_ACK_STATUS === "C");
    const latestCommandInfo = (localServer_info.commandInfo || []).find(info => info.LAST_REQUEST_ID === localServer_info.commandRequestId);
    const sendAdminCommand = (commandName, requestedCodecs) => {
        if (isCommandPending) return;
        if (commandName === "codecConfigApply" && requestedCodecs && !Object.values(requestedCodecs).some(value => value === "Y")) {
            setCommandAlert({ kind: ConstData.ALERT_KIND.DANGER, message: t("명령_코덱_하나_필요", { ns: "admin" }) });
            return;
        }
        setIsCommandPending(true);
        setPendingCommandName(commandName);
        const codecs = commandName === "codecConfigApply" ? [
            { codecName: "VP9", useYn: requestedCodecs ? requestedCodecs.VP9 : codecConfig.VP9 },
            { codecName: "VP8", useYn: requestedCodecs ? requestedCodecs.VP8 : codecConfig.VP8 },
            { codecName: "H264", useYn: requestedCodecs ? requestedCodecs.H264 : codecConfig.H264 }
        ] : undefined;
        handleSelectedFunc({ selectedFunc: "SEND_LOCAL_SERVER_COMMAND", data: { localServerSeq: localServer_info.localServerSeq, commandName, codecs } });
    };

    // 260804 상세정보(생성일 제외) NULL 값은 "-"로 표시
    const formatOrDash = (value) => (value !== undefined && value !== null && value !== "" ? value : "-");
    const reportTokenState = getReportTokenState(localServer_info);
    // 20261027 실제 접속 상태가 아닌 MQTT 5 지원 버전 기준으로 색상을 표시한다.
    const rabbitmqVersionSupport = getRabbitmqVersionSupport(localServer_info);
    const rabbitmqVersionBadge = rabbitmqVersionSupport === "supported" ? "online" : rabbitmqVersionSupport === "unsupported" ? "offline" : "neutral";
    // 20261027 수집 실패 후 남은 버전은 현재 정상 정보가 아니라 최근 성공 수집값으로 표시한다.
    const rabbitmqStatus = localServer_info.rabbitmqInfoQueryStatus === "UNAVAILABLE" ? "UNAVAILABLE"
        : ["SUCCESS", "FAILED"].includes(localServer_info.rabbitmqLastCheckStatus) ? localServer_info.rabbitmqLastCheckStatus : "UNKNOWN";
    const rabbitmqStatusStyle = rabbitmqStatus === "SUCCESS" ? "success" : rabbitmqStatus === "FAILED" ? "failed" : "unknown";
    const mqttCheckUnknown = localServer_info.rabbitmqInfoEnabled &&
        (rabbitmqStatus !== "SUCCESS" || !localServer_info.capabilityCheckDt);

    return (
        <>
            {/* teacher/class 탭과 동일한 list-table 행 스타일 (서버 상태 아이콘·핸들러는 기존 그대로 유지) */}
            <tr>
                <td className="text-center">
                    <span className="d-inline-flex align-items-center justify-content-center">
                        <span className="info content hiclass-text">{localServer_info.localServerSeq}</span>
                        {/* 260804 상세정보(읽기전용: 생성일/로그인/로그아웃/IP) 토글 아이콘 */}
                        <FaInfoCircle className="font-sm grey-text ml-1 button" style={{ verticalAlign: 'middle', flexShrink: 0 }} onClick={toggleDetailInfo} title={t("상세정보", { ns: "admin" })} />
                    </span>
                </td>
                <td className="text-center">
                    <div className="d-flex align-items-center justify-content-center local-server-ellipsis-cell">
                        <span className="info content hiclass-text local-server-ellipsis-text" title={localServer_info.localSiteName}>{localServer_info.localSiteName}</span>
                        <FaCog className="font-sm grey-text ml-1 button" style={{ verticalAlign: 'middle', flexShrink: 0 }} onClick={toggleLocalSite} />
                    </div>
                </td>
                {/* 260724 서버 이름 데이터만 왼쪽 정렬 / 260804 폭 축소에 따른 ellipsis 처리 */}
                <td className="text-left local-server-name-cell">
                    <div className="d-flex align-items-center justify-content-start">
                        {
                            localServer_info.serverStatus === "Y" ?
                                <FaBroadcastTower className="font-ml green-text" style={{ flexShrink: 0 }} /> :
                                <FaBroadcastTower className="font-ml red-text" style={{ flexShrink: 0 }} />
                        }
                        {/* 260804-5 "text-area" 클래스가 display:contents라 margin이 무시되던 문제 - 클래스 제거하고 ml-1만 적용 */}
                        {/* 20260828 서버 이름 옆 연필 아이콘 클릭 시 인라인 입력으로 전환, 확인 클릭 시 즉시 저장 */}
                        {/* 20260828 이 div만 d-flex가 빠져 있어 이름이 길면 아이콘이 다음 줄로 밀려 2줄이 되던 문제 수정 - 다른 이름 셀과 동일하게 d-flex 적용 */}
                        <div className="d-flex align-items-center ml-1 local-server-ellipsis-cell" style={{ flex: '1 1 auto' }}>
                            <InlineEditCell
                                value={localServer_info.localServerName}
                                textClassName="info title hiclass-text local-server-ellipsis-text"
                                requiredMessage={t("로컬_서버_이름_입력", { ns: "admin" })}
                                onSave={onHandleChangeServerName}
                            />
                        </div>
                    </div>
                </td>
                <td className="text-center">
                    {/* 260804-8 컬럼 폭을 넓혔지만, 혹시 더 긴 인증 코드가 들어와도 잘렸는지 알 수 있도록 title(호버 툴팁) 추가 */}
                    <span className="info content small hiclass-text admin-ellipsis-text" title={localServer_info.authCode}>{localServer_info.authCode}</span>
                </td>
                <td className="text-center">
                    {
                        localServer_info.isPortOpened ?
                            <FaLockOpen className="font-md green-text" /> :
                            <FaLock className="font-md red-text" />
                    }
                </td>
                <td className="text-center">
                    <div className="d-flex align-items-center justify-content-center flex-wrap" style={{ gap: '4px' }}>
                        <button className="btn-table-action" type="button" onClick={togglePortInfo}>
                            {t("포트관리", { ns: "admin" })}
                        </button>
                        {/* 260804 상세설정(로그인 허용/자동 로그인/업데이트 허용) 버튼 - 업데이트 가능 여부도 이 안에서 확인/변경 */}
                        <button className="btn-table-action" type="button" onClick={toggleConfig}>
                            {t("상세설정", { ns: "admin" })}
                        </button>
                        {/* 20260814 로컬 서버별 업데이트·포트 이력 전용 페이지로 이동한다. */}
                        <button className="btn-table-action" type="button" onClick={() => handleSelectedFunc({ selectedFunc: "LOCAL_SERVER_HISTORY", data: localServer_info })}>
                            {t("이력", { ns: "admin" })}
                        </button>
                    </div>
                </td>
            </tr>
            {/* 20260828 이름 인라인 수정 결과 - 상세설정 저장과 동일하게 해당 행 바로 아래에서만 표시하고 2.5초 후 사라진다 */}
            {nameAlert.kind !== ConstData.ALERT_KIND.NONE &&
                <tr className="b-none local-server-detail-row">
                    <td colSpan={6} className="p-0">
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="area-90 mt-1">
                                <Alerts kind={nameAlert.kind} message={nameAlert.message} />
                            </div>
                        </div>
                    </td>
                </tr>
            }
            {/* 260804-6 요청한 표시 순서: 상세정보 표시 -> 상세설정 -> 포트 번호 설정 -> 로컬 사이트 설정 */}
            {/* 260804 상세정보 - 읽기전용 (생성일/마지막 로그인/마지막 로그아웃/마지막 로그인 IP), 생성일 외에는 NULL이면 "-" 표시 */}
            <tr className="b-none local-server-detail-row">
                <td colSpan={6} className="p-0">
                    <Collapse isOpen={isDetailInfoOpen} className="w-100">
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="area-90 local-server-panel-card mt-2">
                                {/* 20261027 항목별 최소 너비 대신 공통 그리드를 사용해 상세정보 열을 일치시킨다. */}
                                <div className="local-server-info-grid">
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("생성일", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.createDt)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("마지막_로그인", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.serverLoginDt)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("마지막_로그아웃", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.serverLogoutDt)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("마지막_로그인_IP", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.ipAddress)}</span>
                                    </div>
                                    {/* 20260814 운영 판단에 필요한 서버 타입·업데이트·MQTT 상태를 읽기전용으로 표시한다. */}
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("로컬_서버_타입", { ns: "admin" })}</span>
                                        <span className={`local-server-type-badge local-server-type-${localServer_info.localServerType && localServer_info.localServerType !== "UNKNOWN" ? "configured" : "unknown"}`}>{t(`서버_타입_${localServer_info.localServerType || "UNKNOWN"}`, { ns: "admin", defaultValue: localServer_info.localServerTypeName || "-" })}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("설치_SVN_리비전", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.installedSvnRevision)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("마지막_업데이트_상태", { ns: "admin" })}</span>
                                        {localServer_info.lastUpdateStatus ? <span className={`local-update-status-badge update-status-${getUpdateStatusStyle(localServer_info.lastUpdateStatus)}`}>{localServer_info.lastUpdateStatus}</span> : <span className="font-md hiclass-text">-</span>}
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("마지막_업데이트_시각", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.lastUpdateDt)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("MQTT_사용_가능", { ns: "admin" })}</span>
                                        <span title={localServer_info.rabbitmqInfoEnabled ? t("RabbitMQ_지원_판정_설명", { ns: "admin" }) : undefined} className={`local-server-state-badge server-state-${!mqttCheckUnknown && localServer_info.mqttAvailableYn === "Y" ? "online" : "neutral"}`}>{mqttCheckUnknown ? t("필터_확인_안됨", { ns: "admin" }) : localServer_info.mqttAvailableYn === "Y" ? "Y" : "N"}</span>
                                    </div>
                                    {/* 20261027 새 수집 기능이 활성화된 테스트 클라우드 목록에만 버전 상세를 표시한다. */}
                                    {localServer_info.rabbitmqInfoEnabled && <>
                                        <div className="d-flex flex-column">
                                            <span className="font-sm grey-text">{t("RabbitMQ_서버_버전", { ns: "admin" })}</span>
                                            <span className={`local-server-state-badge server-state-${rabbitmqVersionBadge}`} title={`${t(`RabbitMQ_버전_${rabbitmqVersionSupport}`, { ns: "admin" })} — ${t("RabbitMQ_버전_배지_설명", { ns: "admin" })}`} aria-label={`${formatOrDash(localServer_info.rabbitmqVersion)}: ${t(`RabbitMQ_버전_${rabbitmqVersionSupport}`, { ns: "admin" })}`}>{formatOrDash(localServer_info.rabbitmqVersion)}</span>
                                            {localServer_info.rabbitmqVersion && rabbitmqStatus !== "SUCCESS" && <span className="font-sm grey-text">{t("RabbitMQ_최근_성공_수집값", { ns: "admin" })}</span>}
                                        </div>
                                        <div className="d-flex flex-column">
                                            <span className="font-sm grey-text">{t("RabbitMQ_버전_수집_상태", { ns: "admin" })}</span>
                                            <span title={t("RabbitMQ_수집_상태_설명", { ns: "admin" })} className={`local-update-status-badge update-status-${rabbitmqStatusStyle}`}>{t(`RabbitMQ_수집_${rabbitmqStatus}`, { ns: "admin" })}</span>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <span className="font-sm grey-text">{t("RabbitMQ_정상_수집_시각", { ns: "admin" })}</span>
                                            <span className="font-md hiclass-text">{formatOrDash(localServer_info.rabbitmqDetectedDt)}</span>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <span className="font-sm grey-text">{t("RabbitMQ_마지막_확인_시각", { ns: "admin" })}</span>
                                            <span className="font-md hiclass-text">{formatOrDash(localServer_info.rabbitmqLastCheckDt)}</span>
                                        </div>
                                    </>}
                                    {/* 20261027 기능 확인 시각은 MQTT·RabbitMQ 정보 뒤에 표시한다. */}
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("기능_확인_시각", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.capabilityCheckDt)}</span>
                                    </div>
                                    {/* 20261022 토큰 원문 없이 발급·복구 요청·마지막 인증 성공을 표시한다. */}
                                    {/* 20261023 토큰 정보도 기존 상세 항목과 같은 열 너비로 정렬한다. */}
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("보고_토큰_상태", { ns: "admin" })}</span>
                                        <span title={t("보고_토큰_상태_설명", { ns: "admin" })} className={`local-update-status-badge update-status-${reportTokenState.style}`}>{t(`보고_토큰_${reportTokenState.key}`, { ns: "admin" })}</span>
                                        {/* 20261023 초기화는 대상 서버별 재확인 창에서만 수행한다. */}
                                        {/* 20261027 확인창은 필터 결과와 독립된 목록 상위에서 연다. */}
                                        <button type="button" className="btn-table-action btn-danger local-server-token-reset-button align-self-start mt-1" onClick={() => handleSelectedFunc({ selectedFunc: "LOCAL_SERVER_TOKEN_RESET_OPEN", data: { localServerSeq: localServer_info.localServerSeq, localServerName: localServer_info.localServerName } })}>{t("보고_토큰_초기화", { ns: "admin" })}</button>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("보고_토큰_발급_시각", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.reportTokenIssuedDt)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("보고_토큰_인증_시각", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.reportTokenVerifiedDt)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("보고_토큰_복구요청_시각", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.tokenResetRequestDt)}</span>
                                    </div>
                                    {/* 20260828 자동 감지 기기 정보는 관리 타입과 구분해 읽기 전용으로 표시한다. */}
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("자동_감지_서버_유형", { ns: "admin" })}</span>
                                        <span className={`local-server-type-badge local-server-type-${localServer_info.detectedServerType && localServer_info.detectedServerType !== "UNKNOWN" ? "configured" : "unknown"}`}>{t(`서버_타입_${localServer_info.detectedServerType || "UNKNOWN"}`, { ns: "admin", defaultValue: localServer_info.detectedServerType || "UNKNOWN" })}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("하드웨어_모델명", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.hardwareModel)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("하드웨어_제조사", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.hardwareVendor)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("하드웨어_아키텍처", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.hardwareArch)}</span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="font-sm grey-text">{t("기기정보_감지_시각", { ns: "admin" })}</span>
                                        <span className="font-md hiclass-text">{formatOrDash(localServer_info.hardwareDetectedDt)}</span>
                                    </div>
                                    {/* 20260828 코덱 이름 자체를 상태 배지로 표시해 활성 여부를 빠르게 구분한다. */}
                                    <div className="d-flex flex-column local-server-info-wide">
                                        <span className="font-sm grey-text">{t("코덱_사용_상태", { ns: "admin" })}</span>
                                        <div className="d-flex align-items-center" style={{ gap: '14px' }}>
                                            {[["VP9", codecConfig.VP9], ["VP8", codecConfig.VP8], ["H264", codecConfig.H264]].map(([codecName, useYn]) =>
                                                <div className="d-flex align-items-center" style={{ flexShrink: 0 }} key={codecName}>
                                                    <span className={`local-server-state-badge server-state-${getCodecStateClass(useYn)}`}>{codecName}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column local-server-info-wide">
                                        <span className="font-sm grey-text">명령 제어</span>
                                        <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
                                            <button type="button" className="btn-table-action" disabled={isCommandPending} onClick={() => sendAdminCommand("commandCapabilityRequest")}>{isCommandPending && <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />}{t("명령_기능_확인", { ns: "admin" })}</button>
                                            {!isCodecConfigOpen && <button type="button" className="btn-table-action" disabled={isCommandPending || !isCommandSupported("codecConfigApply")} onClick={() => setIsCodecConfigOpen(true)}>{t("명령_코덱_재설정", { ns: "admin" })}</button>}
                                            <button type="button" className="btn-table-action" disabled={isCommandPending || !isCommandSupported("restartLocalServer")} onClick={() => sendAdminCommand("restartLocalServer")}>{t("명령_서버_재시작", { ns: "admin" })}</button>
                                        </div>
                                        {isCodecConfigOpen && <div className="d-flex align-items-center flex-wrap mt-1" style={{ gap: '6px' }}>
                                            {["VP9", "VP8", "H264"].map(codecName => <label key={codecName} className="d-flex align-items-center font-sm hiclass-text m-0"><input type="checkbox" checked={codecConfig[codecName] === "Y"} onChange={() => setCodecConfig(prev => ({ ...prev, [codecName]: prev[codecName] === "Y" ? "N" : "Y" }))} className="mr-1" />{codecName}</label>)}
                                            <button type="button" className="btn-table-action" disabled={isCommandPending} onClick={() => sendAdminCommand("codecConfigApply", codecConfig)}>{t("명령_전송", { ns: "admin" })}</button>
                                            {/* 20260918 공통 버튼 문구는 common namespace를 사용한다. */}
                                            <button type="button" className="btn-table-action" disabled={isCommandPending} onClick={() => setIsCodecConfigOpen(false)}>{t("취소", { ns: "common" })}</button>
                                        </div>}
                                        <div className="d-flex align-items-center flex-wrap mt-1" style={{ gap: '6px' }}>
                                            <span className="font-sm grey-text">{t("명령_지원_상태", { ns: "admin" })}</span>
                                            {hasCapabilityResult ? commandUiDefinitions.map(({ commandName, labelKey }) => (
                                                <span key={commandName} className={`local-server-state-badge server-state-${isCommandSupported(commandName) ? "online" : "offline"}`}>
                                                    {t(labelKey, { ns: "admin" })} {t(isCommandSupported(commandName) ? "명령_지원" : "명령_미지원", { ns: "admin" })}
                                                </span>
                                            )) : <span className="font-sm grey-text">{t("명령_지원_확인_필요", { ns: "admin" })}</span>}
                                        </div>
                                        {isCommandPending && <span className="font-sm grey-text mt-1">명령 처리 대기 중...</span>}
                                        {latestCommandInfo && <span className="font-sm grey-text mt-1">{t("명령_상태", { ns: "admin" })}: <span className={`local-update-status-badge update-status-${getCommandStatusStyle(latestCommandInfo.LAST_ACK_STATUS)}`}>{t(`명령_상태_${latestCommandInfo.LAST_ACK_STATUS || "R"}`, { ns: "admin", defaultValue: latestCommandInfo.LAST_ACK_STATUS || "R" })}</span></span>}
                                        {commandAlert.kind !== ConstData.ALERT_KIND.NONE && <Alerts kind={commandAlert.kind} message={commandAlert.message} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </td>
            </tr>
            {/* 260804 상세설정 - 업데이트 허용/로그인 허용/자동 로그인 토글 + 저장 (읽기전용 정보와 분리) */}
            <tr className="b-none local-server-detail-row">
                <td colSpan={6} className="p-0">
                    <Collapse isOpen={isConfigOpen} className="w-100">
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="d-flex flex-column area-90 local-server-panel-card mt-2">
                                {/* 20260814 첫째 행에는 기존 권한 토글만 배치한다. */}
                                <div className="d-flex align-items-center flex-wrap w-100" style={{ gap: '18px' }}>
                                    <label className="d-flex align-items-center local-server-panel-toggle hiclass-switch-label m-0">
                                        <span className="local-server-panel-label mr-2">{t("업데이트_허용", { ns: "admin" })}</span>
                                        <span className="hiclass-switch">
                                            <input type="checkbox" checked={lUpdateAllowYn === "Y"} onChange={onToggleUpdateAllowYn} />
                                            <span className="hiclass-switch-slider" />
                                        </span>
                                    </label>
                                    {/* 20260814 종속 관계가 잘 보이도록 클래스 모니터 허용을 업데이트 허용 다음에 배치한다. */}
                                    <label className="d-flex align-items-center local-server-panel-toggle hiclass-switch-label m-0">
                                        <span className="local-server-panel-label mr-2">{t("클래스_모니터_허용", { ns: "admin" })}</span>
                                        <span className="hiclass-switch">
                                            <input type="checkbox" checked={isClassMonitorConfigEnabled && lClassMonitorAllowYn === "Y"} onChange={onToggleClassMonitorAllowYn} disabled={!isClassMonitorConfigEnabled} />
                                            <span className="hiclass-switch-slider" />
                                        </span>
                                    </label>
                                    <label className="d-flex align-items-center local-server-panel-toggle hiclass-switch-label m-0">
                                        <span className="local-server-panel-label mr-2">{t("로그인_허용", { ns: "admin" })}</span>
                                        <span className="hiclass-switch">
                                            <input type="checkbox" checked={lAllowLoginYn === "Y"} onChange={onToggleAllowLoginYn} />
                                            <span className="hiclass-switch-slider" />
                                        </span>
                                    </label>
                                    <label className="d-flex align-items-center local-server-panel-toggle hiclass-switch-label m-0">
                                        <span className="local-server-panel-label mr-2">{t("자동_로그인", { ns: "admin" })}</span>
                                        <span className="hiclass-switch">
                                            <input type="checkbox" checked={lAllowLoginYn === "Y" && lAutoLoginYn === "Y"} onChange={onToggleAutoLoginYn} disabled={lAllowLoginYn !== "Y"} />
                                            <span className="hiclass-switch-slider" />
                                        </span>
                                    </label>
                                    {/* 20260814 클래스 모니터를 허용한 경우에만 MQTT 접속 조건을 안내한다. */}
                                    {lClassMonitorAllowYn === "Y" && !isMqttPortAvailable &&
                                        <span className="font-sm red-text">{t("클래스_모니터_MQTT_대기", { ns: "admin" })}</span>
                                    }
                                </div>
                                {/* 20260814 둘째 행에는 서버 타입 선택만 배치한다. */}
                                <div className="d-flex align-items-center flex-wrap w-100 mt-3" style={{ gap: '12px' }}>
                                    <label className="d-flex align-items-center m-0">
                                        {/* 20260814 타입 라벨을 충분히 확보해 두 줄로 접히지 않게 표시한다. */}
                                        <span className="local-server-panel-label mr-2" style={{ minWidth: '145px', whiteSpace: 'nowrap' }}>{t("로컬_서버_타입", { ns: "admin" })}</span>
                                        <select className="custom-select small local-server-panel-select" style={{ minWidth: '240px' }} value={lLocalServerType} onChange={(e) => setLocalServerType(e.target.value)}>
                                            {/* 20260828 신규 등록과 달리 기존 서버 수정에서는 사용 중지된 타입도 선택할 수 있게 한다. */}
                                            {(list_localServerType || []).map(info => <option value={info.localServerType} key={info.localServerType}>{t(`서버_타입_${info.localServerType}`, { ns: "admin", defaultValue: info.localServerTypeName })}</option>)}
                                        </select>
                                    </label>
                                </div>
                                {/* 20260814 셋째 행 중앙에 생성 패널과 같은 글자형 저장 버튼을 표시한다. */}
                                <div className="d-flex align-items-center justify-content-center w-100 mt-3">
                                    <button type="button" className="btn btn-md hiclasstv-blue white-text m-0 px-4 py-1" onClick={() => onHandleSaveConfig()}>
                                        <b>{t("저장", { ns: "common" })}</b>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="area-90">
                                <Alerts kind={configAlert.kind} message={configAlert.message} />
                            </div>
                        </div>
                    </Collapse>
                </td>
            </tr>
            <tr className="b-none local-server-detail-row">
                <td colSpan={6} className="p-0">
                    {/* <UncontrolledCollapse toggler={"#changePortInfo_" + idx} className="w-100" defaultOpen={false}> */}
                    <Collapse isOpen={isPortInfoOpen} className="w-100">
                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                            {/* 260804-4 패널 간 상단 간격 통일을 위해 mb-2 -> mt-2 */}
                            {
                                localServer_info.isPortOpened ?
                                    <div className="area-90 local-server-panel-card mt-2">
                                        <div className="local-server-panel-grid local-server-port-panel-grid">
                                            <div className="local-server-panel-field">
                                                <span className="local-server-panel-label">{t("포트_번호", { ns: "admin" })}</span>
                                                <span className="local-server-panel-value">{localServer_info.portNumber}</span>
                                            </div>
                                            <div className="local-server-panel-field local-server-panel-field-wide">
                                                <span className="local-server-panel-label">{t("메모", { ns: "admin" })}</span>
                                                <span className="local-server-panel-value">{localServer_info.historyMemo !== undefined && localServer_info.historyMemo !== null ? localServer_info.historyMemo : t("없음", { ns: "admin" })}</span>
                                            </div>
                                        </div>
                                        <div className="local-server-panel-action-row">
                                            <button type="button" className="btn-table-action btn-danger" title={t("포트닫기", { ns: "admin" })} id={"changePortInfo" + idx} onClick={() => handleSelectedFunc({ selectedFunc: "CLOSE_LOCAL_SERVER_PORT", data: { localServer_info } })}>
                                                {t("닫기", { ns: "common" })}
                                            </button>
                                        </div>
                                    </div> :
                                    <div className="area-90 local-server-panel-card mt-2">
                                        <div className="local-server-panel-grid local-server-port-panel-grid">
                                            <label className="local-server-panel-field m-0">
                                                <span className="local-server-panel-label">{t("포트_번호", { ns: "admin" })}</span>
                                            <input
                                                type="text"
                                                value={lPortNumber}
                                                    className="web-search-input transparent local-server-panel-input m-0"
                                                placeholder={lPortNumber && lPortNumber !== "" ? lPortNumber : t("포트번호", { ns: "admin" })}
                                                onChange={onChangePortNumber}
                                            />
                                            </label>
                                            <label className="local-server-panel-field local-server-panel-field-wide m-0">
                                                <span className="local-server-panel-label">{t("메모", { ns: "admin" })}</span>
                                            <input
                                                type="text"
                                                value={lMemo}
                                                    className="web-search-input transparent local-server-panel-input m-0"
                                                placeholder={lMemo && lMemo !== "" ? lMemo : t("메모_입력_안내", { ns: "admin" })}
                                                onChange={onChangeMemo}
                                            />
                                            </label>
                                        </div>
                                        <div className="local-server-panel-action-row">
                                            <button type="button" className="btn btn-md hiclasstv-blue white-text m-0 px-4 py-1" title={t("포트열기", { ns: "admin" })} onClick={() => onHandleLocalServerPortNumber()} disabled={localServer_info.serverStatus !== "Y"}>
                                                <b>{t("열기", { ns: "common" })}</b>
                                            </button>
                                        </div>
                                    </div>
                            }
                            {
                                localServer_info.remoteForwardResult && localServer_info.remoteForwardResult.success !== null &&
                                <div className="d-flex align-items-center justify-content-start area-90 round p-2 mb-2"
                                    style={{ backgroundColor: localServer_info.remoteForwardResult.success ? '#d4edda' : '#f8d7da', fontSize: '0.85rem' }}>
                                    <div className="d-flex align-items-center" style={{ width: '100%' }}>
                                        {localServer_info.remoteForwardResult.success ?
                                            <FaCheckCircle className="font-md green-text mr-2" /> :
                                            <FaTimesCircle className="font-md red-text mr-2" />
                                        }
                                        <span className="font-weight-bold mr-2">
                                            {localServer_info.remoteForwardResult.success ? '성공' : '실패'}:
                                        </span>
                                        <span className="mr-2">Port {localServer_info.remoteForwardResult.localPort}</span>
                                        <span style={{ color: '#666' }}>
                                            {localServer_info.remoteForwardResult.message}
                                        </span>
                                        {localServer_info.remoteForwardResult.timestamp && (
                                            <span className="ml-auto" style={{ fontSize: '0.75rem', color: '#999' }}>
                                                {new Date(localServer_info.remoteForwardResult.timestamp).toLocaleString('ko-KR')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            }
                        </div>
                        {
                            /* localServer_info.isPortOpened ?
                                <div className="d-flex flex-column align-items-center justify-content-center w-100">
                                    <div className="d-flex align-items-center justify-content-around area-90 hiclasstv-lightgrey round p-2 mb-2">
                                        <div className="d-flex area-30 align-items-center font-md">
                                            <span className="font-weight-bold">{t("포트_번호", { ns: "admin" })} &nbsp;</span>
                                            [{localServer_info.portNumber}]
                                        </div>
                                        <div className="d-flex area-50 font-md">
                                            <span className="font-weight-bold">{t("메모", { ns: "admin" })} </span>
                                            {localServer_info.historyMemo !== undefined && localServer_info.historyMemo !== null ? localServer_info.historyMemo : t("없음", { ns: "admin" })}
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center area-10">
                                            <button type="button" className="btn-table-action btn-danger" title={t("포트닫기", { ns: "admin" })} id={"changePortInfo" + idx} onClick={() => handleSelectedFunc({ selectedFunc: "CLOSE_LOCAL_SERVER_PORT", data: { localServer_info } })}>
                                                {t("닫기", { ns: "common" })}
                                            </button>
                                        </div>
                                    </div>
                                </div> :
                                <div className="d-flex flex-column align-items-center justify-content-center w-100">
                                    <div className="d-flex align-items-center justify-content-between area-90 hiclasstv-lightgrey round p-2 pl-4 mb-2">
                                        <div className="d-flex area-30 align-items-center font-md">
                                            <span className="font-weight-bold">{t("포트_번호", { ns: "admin" })}&nbsp;</span>
                                            <input
                                                type="text"
                                                value={lPortNumber}
                                                className="web-search-input transparent area-50 m-0"
                                                placeholder={lPortNumber && lPortNumber !== "" ? lPortNumber : t("포트번호", { ns: "admin" })}
                                                onChange={onChangePortNumber}
                                            />
                                        </div>
                                        <div className="d-flex area-50 align-items-center font-md">
                                            <span className="font-weight-bold">{t("메모", { ns: "admin" })}&nbsp;</span>
                                            <input
                                                type="text"
                                                value={lMemo}
                                                className="web-search-input transparent area-80 m-0"
                                                placeholder={lMemo && lMemo !== "" ? lMemo : t("메모_입력_안내", { ns: "admin" })}
                                                onChange={onChangeMemo}
                                            />
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center area-10">
                                            {
                                                localServer_info.serverStatus === "Y" ?
                                                    <button type="button" className="d-flex transparent b-none rounded p-1" title={t("포트열기", { ns: "admin" })} onClick={() => onHandleLocalServerPortNumber()}>
                                                        <FaCheckCircle className="d-flex font-md m-1 green-text" />
                                                    </button> :
                                                    <button type="button" className="d-flex transparent b-none rounded p-1" title={t("포트열기", { ns: "admin" })} onClick={() => onHandleLocalServerPortNumber()} disabled={localServer_info.serverStatus === "N"}>
                                                        <FaCheckCircle className="d-flex font-md m-1 light-grey-text" />
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                </div> */
                        }
                    </Collapse>
                    {/* </UncontrolledCollapse> */}
                </td>
            </tr>
            {/* 260804-6 로컬 사이트 설정을 순서상 마지막으로 이동, 다음 서버 행과의 하단 여백 유지를 위해 mb-2 추가 */}
            <tr className="b-none local-server-detail-row">
                <td colSpan={6} className="p-0">
                    {/* <UncontrolledCollapse toggler={"#changeLocalSite_" + idx} className="w-100" defaultOpen={false}> */}
                    <Collapse isOpen={isLocalSiteOpen} className="w-100">
                        {
                            <div className="d-flex align-items-center justify-content-center w-100">
                                <div className="area-90 local-server-panel-card mt-2 mb-2">
                                    <label className="local-server-panel-field m-0">
                                        <span className="local-server-panel-label">{t("로컬_사이트", { ns: "admin" })}</span>
                                        <select className="custom-select small local-server-panel-select my-1" style={{ width: '100%' }} value={lLocalSiteInfo.idx} onChange={onChangeSelectLocalSite}>
                                            {
                                                list_localSite && list_localSite.length > 0 ?
                                                    list_localSite.map((info, index) => (
                                                        <option value={index} key={"itemOption-" + index}>{info.localSiteName}</option>
                                                    )) :
                                                    <option value={-1}>
                                                        {t("선택_가능한_로컬_사이트_없음", { ns: "admin" })}
                                                    </option>
                                            }
                                        </select>
                                    </label>
                                    <div className="local-server-panel-action-row">
                                        <button type="button" className="btn btn-md hiclasstv-blue white-text m-0 px-4 py-1" title={t("저장", { ns: "common" })} onClick={() => onHandleModifyLocalSite()}>
                                            <b>{t("저장", { ns: "common" })}</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                    </Collapse>
                    {/* </UncontrolledCollapse> */}
                </td>
            </tr>
        </>
    );
}

export default WebLocalServerInfo;
